import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { doc, deleteDoc } from "firebase/firestore";
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { db } from "../../../firebase";
import Iconify from "../../../components/Iconify";

/*
  We rely on the parent to open the AddPennant or AddMembersToPennant dialog.
  So we only call onEdit(pennant) or onAddMember(pennant).
*/

PennantMoreMenu.propTypes = {
  pennant: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onAddMember: PropTypes.func,
  refreshPennants: PropTypes.func,
};

export default function PennantMoreMenu({ pennant, onEdit, onAddMember, refreshPennants }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = async () => {
    if (window.confirm(`Are you sure you want to delete the pennant: ${pennant.name}?`)) {
      try {
        const pennantDoc = doc(db, "Pennants", pennant.id);
        await deleteDoc(pennantDoc);
        setIsOpen(false);
        if (typeof refreshPennants === "function") {
          refreshPennants();
        }
      } catch (error) {
        console.error("Error deleting pennant: ", error);
      }
    }
  };

  const handleEdit = () => {
    if (typeof onEdit === "function") {
      onEdit(pennant);
    }
    setIsOpen(false);
  };

  const handleAddMembers = () => {
    if (typeof onAddMember === "function") {
      onAddMember(pennant);
    }
    setIsOpen(false);
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{ sx: { width: 200, maxWidth: "100%" } }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem sx={{ color: "text.secondary" }} onClick={handleDelete}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: "body2" }} />
        </MenuItem>

        <MenuItem sx={{ color: "text.secondary" }} onClick={handleEdit}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: "body2" }} />
        </MenuItem>

        <MenuItem sx={{ color: "text.secondary" }} onClick={handleAddMembers}>
          <ListItemIcon>
            <Iconify icon="eva:person-add-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Manage Members" primaryTypographyProps={{ variant: "body2" }} />
        </MenuItem>
      </Menu>
    </>
  );
}
